<template>
  <div class="shopping_note" style="background-image: url('/img/callback.jpg')">
    <b-container class="py-5">
      <div class="shopping_note-card" v-html="note"></div>
    </b-container>
  </div>
</template>
<style lang="scss" scoped>
.shopping_note {
  min-height: calc((var(--vh, 1vh) * 100) - 104px - 64px - 35px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  &-card {
    background-color: rgba(#fff, 0.9);
    padding: 30px;
  }
}
</style>
<script>
import { ShoppingNote } from "@/assets/api/platform.js";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "ShoppingNote",
  props: ["token"],
  data() {
    return {
      note: ""
    };
  },
  created() {
    this.getShoppingCar();
  },
  methods: {
    getShoppingCar() {
      ShoppingNote.get(this.token)
        .then(res => {
          if (res.status <= 201) {
            this.note = res.data.content;
          } else {
            Toast.fire({
              icon: "error",
              title: "購物須知讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>
